/**
 * `<UserLink>` — an app username as a link to its profile (Users page,
 * TRIAG-427). Safe inside clickable table rows: click and Enter don't bubble
 * to the row (precedent: DuplicatesTable.tsx). Never renders "@".
 */
import type { ReactNode } from "react";
import { Link } from "react-router";

import { userHref } from "@/lib/user-link";
import { cn } from "@/lib/utils";

export function UserLink({
  username,
  className,
  children,
}: {
  username: string;
  className?: string;
  /** Defaults to the username itself. */
  children?: ReactNode;
}) {
  return (
    <Link
      to={userHref(username)}
      title={`Open the profile of ${username}`}
      // Rows on /bundles and /duplicates are clickable <tr>s: keep the row's
      // own navigation from firing too. Default (navigation) still happens.
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.stopPropagation();
      }}
      className={cn(
        "font-medium text-blue-700 underline-offset-4 hover:underline focus-visible:rounded focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:text-blue-400",
        className,
      )}
    >
      {children ?? username}
    </Link>
  );
}
